import ValidityHelper from '../../../../Helpers/ValidityHelper';
import InputTypesEnum from '../../../../Enums/InputTypesEnum';
import RequestPaymentDetailsReviewItem from './RequestPaymentDetailsReviewItem';
import PaymentExportAllExportService from '../../../../Services/PaymentExportAllExportService';

export default class RequestPaymentDetailsReviewWindowDescription {
  static titleForCreate = 'Request Payment Details Review';
  static titleForEdit = 'Request Payment Details Review';
  static finishButtonLabel = 'Request Review';
  static itemType = RequestPaymentDetailsReviewItem;
  static serviceFunction = (edited) => PaymentExportAllExportService.postRequestPaymentDetailsReviewFile(edited);
  static waitForServiceFunction = () => false;
  static messageOnSuccess =
    'The review request has been started. You will receive a notification about the result in your personal notification repository.';

  static pagesInGeneralEditWizzard = [
    {
      label: 'General',
      fields: [
        {
          fieldName: 'file',
          label: 'Payment Export Summary File',
          className: 'col-12',
          type: InputTypesEnum.FileUploadField,
          acceptedTypes: '.xlsx, .xls, .csv',
          validityChecker: ValidityHelper.forRequiredFileField,
        },
      ],
    },
  ];
}
